import { render, staticRenderFns } from "./registrationname.vue?vue&type=template&id=4e5000d0&scoped=true"
import script from "./registrationname.vue?vue&type=script&lang=js"
export * from "./registrationname.vue?vue&type=script&lang=js"
import style0 from "./registrationname.vue?vue&type=style&index=0&id=4e5000d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5000d0",
  null
  
)

export default component.exports